import { Modal as MuiModal, type ModalProps } from '@mui/material';
import { BoxProps } from '@mui/material';
import { StyledModalBox } from './styled/modal.styled';

export interface CustomModalProps extends ModalProps {
  boxProps?: BoxProps;
}

export const Modal = ({
  children,
  open,
  boxProps,
  ...props
}: CustomModalProps) => {
  return (
    <MuiModal open={open} {...props}>
      <StyledModalBox {...boxProps}>{children}</StyledModalBox>
    </MuiModal>
  );
};
